/* eslint-disable */

export const options = ({ domainId, hasCommerce }) => {
    let data = [
        {
            id: 'allDomain',
            clearAllSelected: true,
            title: 'All Domains',
            href: '/domains/',
            icon: 'icon-fi_grid-converted',
        },
        {
            id: 'googleSurfaces',
            title: 'Google Surfaces',
            icon: 'icon-google-outline-svgrepo-com-1-converted-1',
            href: `/domains/${domainId}/google-surfaces/`,
            clearAllSelected: true,
            requiredDaomin: true,
        },
        {
            id: 'opportunities',
            title: 'Opportunities',
            collapsTargetId: 'collapseOpportunity',
            icon: 'icon-target-04-converted',
            clearAllSelected: true,
            requiredDaomin: true,
            children: [
                {
                    id: 'opportunities_SEO_Recommendations',
                    title: 'Search Recommendations',
                    pathnames: [`/domains/${domainId}/opportunities/search/`],
                    href: `/domains/${domainId}/opportunities/search/?view=striking_distance`,
                    icon: 'icon-compass-03',
                    parent: 'opportunities',
                },
                {
                    id: 'opportunities_Discover',
                    title: 'Discover Recommendations',
                    href: `/domains/${domainId}/opportunities/recommendations/`,
                    icon: 'icon-file-search',
                    parent: 'opportunities',
                },
            ],
        },
        {
            id: 'discover_analytics',
            title: 'Discover Analytics',
            icon: 'icon-iconly_svg_converted-converted',
            collapsTargetId: 'collapseDiscoverAnalytics',
            clearAllSelected: true,
            requiredDaomin: true,
            children: [
                {
                    id: 'discover_analytics_overview',
                    title: 'Overview',
                    href: `/domains/${domainId}/`,
                    icon: 'icon-pie-chart',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_categories',
                    title: 'Categories',
                    pathnames: [
                        `/domains/${domainId}/categories/`,
                        `/domains/${domainId}/categories/category/`,
                    ],
                    href: `/domains/${domainId}/categories/`,
                    icon: 'icon-fi_grid',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_entities',
                    title: 'Entities',
                    pathnames: [
                        `/domains/${domainId}/entities/`,
                        `/domains/${domainId}/entities/entity/`,
                    ],
                    href: `/domains/${domainId}/entities/`,
                    icon: 'icon-building-06',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_pages',
                    title: 'Pages',
                    pathnames: [`/domains/${domainId}/pages/`, `/domains/${domainId}/pages/page/`],
                    href: `/domains/${domainId}/pages/`,
                    icon: 'icon-lightbulb-03',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_authors',
                    title: 'Authors',
                    pathnames: [
                        `/domains/${domainId}/authors/`,
                        `/domains/${domainId}/authors/author/`,
                    ],
                    href: `/domains/${domainId}/authors/`,
                    icon: 'icon-n_author-performance-1',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_competitive_analysis',
                    title: 'Competitive Analysis',
                    href: `/domains/${domainId}/competitive-analysis/`,
                    icon: 'icon-list-ol',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_entity_clusters',
                    title: 'Entity Clusters',
                    href: `/domains/${domainId}/connected-entities/`,
                    icon: 'icon-network',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_algo_comparison',
                    title: 'Algo Comparison',
                    href: `/domains/${domainId}/algo-comparison/`,
                    icon: 'icon-scale-1',
                    parent: 'discover_analytics',
                },
                {
                    id: 'discover_analytics_stats',
                    title: 'Stats',
                    icon: 'icon-position-distribution',
                    collapsTargetId: 'collapseDiscoverStats',
                    parent: 'discover_analytics',
                    children: [
                        {
                            id: 'discover_analytics_stats_stats',
                            title: 'Stats',
                            href: `/domains/${domainId}/stats/`,
                            icon: 'icon-area-chart',
                            parent: 'discover_analytics_stats',
                        },
                        {
                            id: 'discover_analytics_stats_search_appearances',
                            title: 'Search Appearances',
                            icon: 'icofont-binoculars',
                            href: `/domains/${domainId}/appearances/`,
                            parent: 'discover_analytics_stats',
                        },
                        {
                            id: 'discover_analytics_stats_countries',
                            title: 'Countries',
                            icon: 'icofont-globe',
                            href: `/domains/${domainId}/countries/`,
                            parent: 'discover_analytics_stats',
                        },
                    ],
                },
            ],
        },
        {
            id: 'discover_tracking',
            title: 'Discover Tracking',
            icon: 'icon-compass-03-converted ',
            collapsTargetId: 'collapseDiscoverTracking',
            clearAllSelected: true,
            children: [
                {
                    id: 'discover_tracking_entity',
                    title: 'Discover Entity Tracking',
                    href: `/tools/google-discover-data/`,
                    icon: 'icon-algo',
                    parent: 'discover_tracking',
                    hrefStartsWith: '/tools/google-discover-data/',
                },
            ],
        },
        {
            id: 'searchAnalytics',
            title: 'Search Analytics',
            icon: 'icon-file-search-01-converted',
            collapsTargetId: 'collapseTwo',
            clearAllSelected: true,
            requiredDaomin: true,
            children: [
                {
                    id: 'search_analytics_overview',
                    title: 'Overview',
                    href: `/domains/${domainId}/gsc-reports/`,
                    icon: 'icon-summary',
                    parent: 'searchAnalytics',
                },
                {
                    id: 'search_analytics_keywords',
                    title: 'Keywords',
                    icon: 'icon-key',
                    collapsTargetId: 'collapseKeywords',
                    parent: 'searchAnalytics',
                    children: [
                        {
                            id: 'search_analytics_keywords_keywords',
                            title: 'Keywords',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/keywords/`,
                                `/domains/${domainId}/gsc-reports/keywords/keyword/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/keywords/`,
                            icon: 'icon-keywords',
                            parent: 'search_analytics_keywords',
                        },
                        {
                            id: 'search_analytics_striking_distance',
                            title: 'Striking Distance',
                            icon: 'icon-striking_distance',
                            href: `/domains/${domainId}/gsc-reports/striking-distance/`,
                            parent: 'search_analytics_keywords',
                        },
                        {
                            id: 'search_analytics_keyword_clusters',
                            title: 'Keyword Clusters',
                            icon: 'icon-keyword_cluster',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/keyword-clusters/`,
                                `/domains/${domainId}/gsc-reports/keyword-clusters/cluster/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/keyword-clusters/`,
                            parent: 'search_analytics_keywords',
                        },
                        {
                            id: 'search_analytics_manual_keyword_lists',
                            title: 'Manual Keyword Lists',
                            icon: 'icon-striking_distance',
                            href: `/domains/${domainId}/gsc-reports/manual-keyword-list/`,
                            parent: 'search_analytics_keywords',
                        },
                    ],
                },
                {
                    id: 'search_analytics_urls',
                    title: 'URLs',
                    icon: 'icon-link-01',
                    collapsTargetId: 'collapseURLs',
                    parent: 'searchAnalytics',
                    requiredDaomin: true,
                    children: [
                        {
                            id: 'search_analytics_urls_urls',
                            title: 'URLs',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/urls/`,
                                `/domains/${domainId}/gsc-reports/urls/url/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/urls/`,
                            icon: 'icon-urls',
                            parent: 'search_analytics_urls',
                        },
                        {
                            id: 'search_analytics_urls_directories',
                            title: 'Directories',
                            icon: 'icon-directories',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/directories/`,
                                `/domains/${domainId}/gsc-reports/directories/directory/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/directories/`,
                            parent: 'search_analytics_urls',
                        },
                        {
                            id: 'search_analytics_urls_subdomains',
                            title: 'Subdomains',
                            icon: 'icon-subdomains',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/subdomains/`,
                                `/domains/${domainId}/gsc-reports/subdomains/subdomain/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/subdomains/`,
                            parent: 'search_analytics_urls',
                        },
                        {
                            id: 'search_analytics_urls_manual_URL_lists',
                            title: 'Manual URL Lists',
                            icon: 'icofont-globe',
                            pathnames: [
                                `/domains/${domainId}/gsc-reports/manual-url-list/`,
                                `/domains/${domainId}/gsc-reports/manual-url-list/cluster/`,
                            ],
                            href: `/domains/${domainId}/gsc-reports/manual-url-list/`,
                            parent: 'search_analytics_urls',
                        },
                    ],
                },
                {
                    id: 'search_analytics_evergreen',
                    title: 'Evergreen',
                    icon: 'icon-infinity',
                    collapsTargetId: 'collapseEvergreen',
                    parent: 'searchAnalytics',
                    children: [
                        {
                            id: 'search_analytics_evergreen_url',
                            title: 'Evergreen URLs',
                            href: `/domains/${domainId}/gsc-reports/evergreen/`,
                            icon: 'icon-evergreen',
                            parent: 'search_analytics_evergreen',
                        },
                        {
                            id: 'search_analytics_evergreen_list_keywords',
                            title: '"List" Keywords',
                            icon: 'icon-best_keywords',
                            href: `/domains/${domainId}/gsc-reports/best-keywords/`,
                            parent: 'search_analytics_evergreen',
                        },
                        {
                            id: 'search_analytics_evergreen_year',
                            title: '"Year" Keywords',
                            icon: 'icon-yers_keywords',
                            href: `/domains/${domainId}/gsc-reports/year-keywords/`,
                            parent: 'search_analytics_evergreen',
                        },
                        {
                            id: 'search_analytics_evergreen_questions_keywords',
                            title: '"Questions" Keywords',
                            icon: 'icon-questions',
                            href: `/domains/${domainId}/gsc-reports/questions-keywords/`,
                            parent: 'search_analytics_evergreen',
                        },
                        {
                            id: 'search_analytics_evergreen_custom_keywords',
                            title: '"Custom" Keywords',
                            icon: 'icon-seasons',
                            href: `/domains/${domainId}/gsc-reports/custom-keywords/`,
                            parent: 'search_analytics_evergreen',
                        },
                    ],
                },
                {
                    id: 'search_analytics_algo_comparison',
                    title: 'Algo Comparison',
                    icon: 'icon-scale-1',
                    parent: 'searchAnalytics',
                    pathnames: [`/domains/${domainId}/gsc-reports/algo-comparison/`],
                    href: `/domains/${domainId}/gsc-reports/algo-comparison/?view=overall_performance`,
                },
                {
                    id: 'search_analytics_stats',
                    title: 'Stats',
                    icon: 'icon-bar-chart-10',
                    collapsTargetId: 'collapseStats',
                    parent: 'searchAnalytics',
                    children: [
                        {
                            id: 'search_analytics_stats_position_distribution',
                            title: 'Position Distribution',
                            href: `/domains/${domainId}/gsc-reports/position-distribution/`,
                            icon: 'icon-position-distribution',
                            parent: 'search_analytics_stats',
                        },
                        {
                            id: 'search_analytics_stats_ctr-per-position',
                            title: 'CTR Per Position',
                            icon: 'icon-ctr1',
                            href: `/domains/${domainId}/gsc-reports/ctr-per-position/`,
                            parent: 'search_analytics_stats',
                        },
                        {
                            id: 'search_analytics_stats_search-appearance',
                            title: 'Search Appearance',
                            icon: 'icon-appearances',
                            href: `/domains/${domainId}/gsc-reports/search-appearance/`,
                            parent: 'search_analytics_stats',
                        },
                        {
                            id: 'search_analytics_stats_countries',
                            title: 'Countries',
                            icon: 'icofont-globe',
                            href: `/domains/${domainId}/gsc-reports/countries/`,
                            parent: 'search_analytics_stats',
                        },
                    ],
                },
            ],
        },
        {
            id: 'tools',
            title: 'Tools',
            collapsTargetId: 'collapseTools',
            clearAllSelected: true,
            icon: 'icon-200',
            children: [
                {
                    id: 'tools_explorer',
                    title: 'URL explorer',
                    href: '/domains/tools/live-url/',
                    icon: 'icon-urls',
                    parent: 'tools',
                },
            ],
        },
        {
            id: 'Commerce',
            title: 'Commerce',
            clearAllSelected: true,
            href: '/commerce/',
            hrefStartsWith: '/commerce/',
            isHidden: !hasCommerce,
            icon: 'icon-algo',
        },
    ];

    if (!domainId) data = data.filter((item) => !item.requiredDaomin);

    // function flattenByTitle(data) {
    //     const result = {};

    //     function recurse(items) {
    //         for (const item of items) {
    //             if (item.title) {
    //                 result[item.title] = item.title;
    //             }
    //             if (item.children) {
    //                 recurse(item.children);
    //             }
    //         }
    //     }

    //     recurse(data);
    //     return result;
    // }

    // const titleObjectMap = flattenByTitle(data);

    return data;
};
